import React from 'react';
import classNames from 'classnames';
import { Highlight } from 'react-instantsearch';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import constructImageSourcesArray from '../../../../helpers/constructImageSources';
import Card from '../../../Card';
import type { SearchAllContentArticleHit as Type } from '../../types';

const SearchAllContentArticleHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('SearchAllContentHit', 'SearchAllContentArticleHit');

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Link link={hit.url[0]}>
          <Card.Title title={<Highlight attribute="page_title" hit={hit} />} />
        </Card.Link>

        <div className="Card__content__metadata">
          {hit.article_type_name?.[0] && (
            <Card.Tags tags={[{ type: 'article_type_name', name: hit.article_type_name[0] }]} />
          )}

          <span className="Card__content__url body--small">
            ...{hit.url[0]}
          </span>
        </div>

        <Card.Subtitle
          subtitle={(
            <p className="u-truncate--3">
              {hit.body_summarized?.[0] ? (
                <Highlight attribute="body_summarized" hit={hit} />
              ) : (
                <Highlight attribute="body" hit={hit} />
              )}
            </p>
          )}
        />
      </Card.Content>

      <Card.Image
        image={(
          <Image
            src={constructImageSourcesArray(hit, '4_3')}
            alt={hit.image_alt?.[0]}
            lazyload={false}
          />
        )}
      />
    </Card>
  );
};

export default SearchAllContentArticleHit;
